import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import {
  Popover,
  PopoverContent,
  PopoverTriggerButton,
} from '../../../../CommonComponents/OPL/Popover/Popover';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';

interface Props {
  buttonText?: string;
  onClick?: () => void;
  title: string;
  description: string;
}

export const AccountsPopover: React.FC<Props> = ({
  children,
  onClick,
  buttonText,
  title,
  description,
}) => {
  return (
    <Popover>
      <PopoverTriggerButton onClick={e => e.stopPropagation()}>{children}</PopoverTriggerButton>

      <PopoverContent width={280} side="left">
        <Box display="flex" flexDirection="column" p="16">
          <Text fontWeight={500} color="neutral.700" width="100%" textAlign="left">
            {title}
          </Text>

          <Text color="neutral.500" mt="4" width="100%" textAlign="left">
            {description}
          </Text>

          {onClick && buttonText && (
            <Box mt="8" display="flex" alignItems="flex-start">
              <Button
                variant="link"
                rightIcon="far fa-external-link-square-alt"
                onClick={e => {
                  e.stopPropagation();

                  onClick();
                }}
              >
                {buttonText}
              </Button>
            </Box>
          )}
        </Box>
      </PopoverContent>
    </Popover>
  );
};
